import { Outlet, useLocation, useResolvedPath, Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb';

export default function createBreadcrumbs() {
  return [
    {
      path: '/',
      element: <Breadcrumbs text="Bosh sahifa" />,
      children: [
        { path: 'course-modules', element: <Breadcrumbs text="Kurs Modullari" /> },
        { path: 'lessons', element: <Breadcrumbs text="Darslar" /> },
        { path: 'tests', element: <Breadcrumbs text="Modul Testlari" /> },
        { path: 'exams', element: <Breadcrumbs text="Yakuniy Imtihonlar" /> },
        { path: 'course-skills', element: <Breadcrumbs text="Kurs Ko'nikmalari" /> },
        { path: 'course-technologies', element: <Breadcrumbs text="Kurs Texnologiyalari" /> },
        { path: 'course-projects', element: <Breadcrumbs text="Kurs Loyihalari" /> },
        { path: 'course-partners', element: <Breadcrumbs text="Kurs Hamkorlari" /> },
        { path: 'badges', element: <Breadcrumbs text="Nishonlar (Badges)" /> },
        { path: 'certificates', element: <Breadcrumbs text="Sertifikatlar" /> },
        { path: 'mentors', element: <Breadcrumbs text="Mentorlar" /> },
        { path: 'partners', element: <Breadcrumbs text="Hamkorlar" /> },
        { path: 'graduates', element: <Breadcrumbs text="Bitiruvchilar" /> },
        { path: 'presales', element: <Breadcrumbs text="Presales (Oldindan sotuv)" /> },
        { path: 'promocodes', element: <Breadcrumbs text="Promokodlar" /> },
        { path: 'subscription-plans', element: <Breadcrumbs text="Obuna Rejalari" /> },
        { path: 'notifications', element: <Breadcrumbs text="Bildirishnomalar" /> },
      ],
    },
  ];
}

function Breadcrumbs({ text }: { text: string }) {
  const location = useLocation();
  const resolvedLocation = useResolvedPath('');
  const isActive = location.pathname === resolvedLocation.pathname;

  return (
    <div className="flex gap-1 mb-2">
      <Breadcrumb>
        <BreadcrumbList>
          {isActive ? (
            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold text-slate-700">{text}</BreadcrumbPage>
            </BreadcrumbItem>
          ) : (
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={resolvedLocation.pathname} className="text-slate-500 hover:text-primary">{text}</Link>
              </BreadcrumbLink>
              <BreadcrumbSeparator />
            </BreadcrumbItem>
          )}
        </BreadcrumbList>
      </Breadcrumb>
      <Outlet />
    </div>
  );
}
